import React, { Component } from 'react';

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { Route, Switch, Link } from 'react-router-dom';

import * as profileActions from "../../../actions/profileActions";
import "./style.scss";
// import Logo from "./images/logo.svg";

const $ = window.$;

function containerHeight() {
    var availableHeight = $(window).height() - $('.page-container').offset().top - $('.navbar-fixed-bottom').outerHeight();

    $('.page-container').attr('style', 'min-height:' + availableHeight + 'px');
}

class TopBar extends Component {
    constructor(props) {
        super(props);
    }
    componentDidUpdate() {
        $(document).on('click', '.sidebar-control', function (e) {
            containerHeight();
        });

        // Toggle mini sidebar
        $('.sidebar-main-toggle').off('click').on('click', function (e) {
            e.preventDefault();
            console.log("fsdfsd");
            // Toggle min sidebar class
            $('body').toggleClass('sidebar-xs');
        });
    }
    handleLogoutCLick(e) {
        e.preventDefault();
        this.props.profileActions.ProfileLogout(window.location.pathname);
    }
    render() {
        let { profile } = this.props;
        if (!profile.isAuth) {
            return null;
        }
        return (
            <div className="navbar navbar-inverse navbvar-custom header-highlight ">
                <div className="navbar-header">
                   
                            
                  
                        <Link className="navbar-brand" to="/">
                            {/*<img src={Logo} alt="logo" />*/}
                            <span>XmlDataFeed</span>
                        </Link>
                  
                    <ul className="nav navbar-nav visible-xs-block">
                        <li><a data-toggle="collapse" data-target="#navbar-mobile"><i className="icon-tree5"></i></a></li>
                        {
                            <li><a className="sidebar-mobile-main-toggle"><i className="icon-paragraph-justify3"></i></a></li>
                        }
                    </ul>
                </div>

                <div className="navbar-collapse collapse" id="navbar-mobile">

                    <ul className="nav navbar-nav">
                        <li><a className="sidebar-control sidebar-main-toggle hidden-xs"><i className="icon-paragraph-justify3"></i></a></li>
                    </ul>

                 

                    <ul className="nav navbar-nav navbar-right">

                        <li className="dropdown dropdown-user">
                            <a className="dropdown-toggle" data-toggle="dropdown">
                                <span>{profile.userName}</span>
                                <i className="caret"></i>
                            </a>

                            <ul className="dropdown-menu dropdown-menu-right">
                                {
                                    profile.role === "Admin" ?
                                        <React.Fragment>
                                            <li>
                                                <Link to="/users"><i className="icon-users"></i>Сотрудники</Link>
                                            </li>
                                            <li>
                                                <Link to="/ordersreport"><i className="icon-list"></i>Отчет</Link>
                                            </li>
                                        </React.Fragment>
                                        :null
                                }
                                
                                {/*<li>*/}
                                    {/*<Link to="/profile/changepass"><i className="icon-key"></i>Сменить пароль</Link>*/}
                                {/*</li>*/}
                                <li><a href="" onClick={(e) => this.handleLogoutCLick(e)}><i className="icon-switch2"></i> Выход</a></li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div >
        );
    }
}


function mapStateToProps(state) {
    return {
        profile: state.profile
    }
}

function mapDispatchToProps(dispath) {
    return {
        profileActions: bindActionCreators(profileActions, dispath)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TopBar);


// WEBPACK FOOTER //
// ./src/components/Shared/TopBar/index.jsx